import { postData } from "./Http/api";

// Catálogo propio de los casos cualitativos (Configuraciones Casos Cualitativos). Devuelven la misma forma que
// fetchCasoEstados / fetchCasoEventoTipos de Pre-Judicial para reutilizar la pantalla de gestión de casos.

export const fetchCasoCualitativoEstados = async () => {
  try {
    const response = await postData("/CasoCualitativoEstadoListar", {});
    return (response?.value || []).map((item) => ({
      idCasoEstado: item.idCasoEstado,
      idCasoEtapa: item.idCasoEtapa,
      descripcion: item.descripcion,
      activo: item.activo,
    }));
  } catch (ex) {
    console.error("Error cargando Estados cualitativos:", ex);
    return [];
  }
};

// Tipos de evento activos que se pueden registrar a mano (sin los de sistema: inicio, agenda y cambio de gestor).
export const fetchCasoCualitativoEventoTipos = async () => {
  try {
    const response = await postData("/CasoCualitativoEventoTipoListar", { activo: 1, incluirSistema: false });
    return (response?.value || []).map((item) => ({
      idCasoEventoTipo: item.idCasoEventoTipo,
      descripcion: item.descripcion,
      activo: item.activo,
    }));
  } catch (ex) {
    console.error("Error cargando Tipos de Evento cualitativos:", ex);
    return [];
  }
};
